import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { FileSaverService } from 'ngx-filesaver';
import { IFileDownloader } from './file-downloader.interface';

@Injectable({
    providedIn: 'root'
})
export class FileDownloaderService implements IFileDownloader {
    private readonly document: Document = inject(DOCUMENT);
    private readonly fileSaverService: FileSaverService = inject(FileSaverService);

    downloadBlob(file: Blob, fileName: string): void {
        this.fileSaverService.save(file, fileName);
    }

    downloadFromLink(url: string): void {
        const a: HTMLAnchorElement = document.createElement('a');
        a.href = url;
        this.document.body.appendChild(a);
        a.click();
        this.document.body.removeChild(a);
    }
}
